import React from 'react';
import { Avatar, styled } from '@mui/material';

// Avatar de iniciales (sin foto): fondo blanco con letras OSCURAS (legibles en
// ambos modos) y anillo de acento cuando `border` — así no desaparece sobre las
// superficies claras del modo claro (antes era blanco con texto gris claro).
const StyledUserAvatarInitials = styled(({ size, textSize, border, theme, ...otherProps }) => (
  <Avatar {...otherProps} />
))(({ size, textSize, border, theme }) => ({
  backgroundColor: theme.palette.common.white,
  border: border ? `2px solid ${theme.palette.secondary.main}` : 'none',
  color: theme.palette.ink.main,
  fontSize: theme.typography.pxToRem(textSize),
  fontWeight: 700,
  lineHeight: 1.5,
  height: size,
  width: size
}));

export default StyledUserAvatarInitials;
